export const openExternalLink = (link, target = '_blank') => {
  const a = document.createElement('a')
  a.setAttribute('href', link)
  a.setAttribute('target', target)
  a.click()
}
